/* eslint-disable import/namespace */
/* eslint-disable no-undef */
import "./App.css";

import "./styles/colors.scss";
import "./styles/font.scss";
import "./styles/global.scss";
import "./styles/media.scss";
import "./styles/width.scss";
import "./styles/custom.scss";
import "./assets/css/main.css";

import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import { HelmetProvider } from "react-helmet-async";

import NewUserLayout from "./pages/usersPage/newUserLayout/index";
import UserLoader from "./components/atoms/userLoader";
import { initializeTagManager } from "./gtm/Gtm";
import Usepagetracking from "./usePageTracking/Usepagetracking";
import { GoToTop } from "./services/utils/scrollToTop";

import {
  setSearchCardFocus
} from "./reduxData/sliceData/searchCardReducer";

import {
  setShowDrawer,
  setShowDownloadAppDrawer,
  setShowLoginMobileDrawer
} from "./reduxData/sliceData/homeReducer";

/* ---------------- Lazy Loaded Pages ---------------- */

const BookingConfirmation = lazy(() =>
  import("./pages/usersPage/bookingConfirmation")
);
const BookingFail = lazy(() =>
  import("./pages/usersPage/bookingFail")
);
const ErrorPage = lazy(() =>
  import("./pages/404ErrorPage")
);
const CustomerReviewForm = lazy(() =>
  import("./pages/usersPage/userReview/CustomerHotelReview")
);

const Success = lazy(() => import("./components/payu/Success"));
const Failure = lazy(() => import("./components/payu/Failure"));
const PayUMoneyForm = lazy(() =>
  import("./components/payu/PayUMoneyForm")
);

const CashbackPage = lazy(() =>
  import("./pages/usersPage/cashback")
);
const WalletPage = lazy(() =>
  import("./pages/usersPage/wallet")
);
const NotificationsPage = lazy(() =>
  import("./pages/usersPage/notifications")
);

/* -------------------------------------------------- */

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => initializeTagManager(), 2500);
  }, []);

  useEffect(() => {
    dispatch(setSearchCardFocus(false));
    dispatch(setShowDrawer(false));
    dispatch(setShowDownloadAppDrawer(false));
    dispatch(setShowLoginMobileDrawer(false));
  }, [dispatch]);

  return (
    <div className="App">
      <BrowserRouter>
        <GoToTop />
        <HelmetProvider>
          <Helmet>
            <title>Tripzo</title>
            <meta
              name="description"
              content="Tripzo - India's Fastest Growing Online Travel Booking Brand For Budget Hotels & Holiday Homes."
            />
            <meta
              name="keywords"
              content="Hotels, Resorts, Holidays, Search Hotels"
            />
          </Helmet>
        </HelmetProvider>

        {/* 🔥 Suspense applied here */}
        <Suspense fallback={<UserLoader />}>
          <Routes>
            <Route path="/" element={<NewUserLayout />}>
              <Route path="*" element={<Usepagetracking />} />
            </Route>

            <Route path="/loader" element={<UserLoader />} />

            <Route
              path="/hotel/booking/details/:id"
              element={<BookingConfirmation />}
            />

            <Route
              path="/customer/review/:id/:hotelId"
              element={<CustomerReviewForm />}
            />

            <Route
              path="/customer/review/:id/:hotelId/:userId"
              element={<CustomerReviewForm />}
            />

            <Route
              path="/hotel/booking/fail"
              element={<BookingFail />}
            />

            <Route
              path="/payumoneyform"
              element={<PayUMoneyForm />}
            />

            <Route path="/success" element={<Success />} />
            <Route path="/failure" element={<Failure />} />

            <Route
              path="/payment/success"
              element={<CashbackPage />}
            />
            <Route path="/wallet" element={<WalletPage />} />
            <Route
              path="/notifications"
              element={<NotificationsPage />}
            />

            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
